import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import { AuthProvider, RequireAuth } from './lib/AuthContext';
import HomePage from './pages/HomePage';
import EntitiesPage from './pages/EntitiesPage';
import EntityPage from './pages/EntityPage';
import CardPage from './pages/CardPage';
import AboutPage from './pages/AboutPage';
import CorrectionsPage from './pages/CorrectionsPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import NotFoundPage from './pages/NotFoundPage';

// Admin pages
import AdminLoginPage from './pages/admin/LoginPage';
import AdminDashboardPage from './pages/admin/DashboardPage';
import AdminCardEditPage from './pages/admin/CardEditPage';
import AdminSourceNewPage from './pages/admin/SourceNewPage';
import AdminReviewQueuePage from './pages/admin/ReviewQueuePage';
import AdminIntakeInboxPage from './pages/admin/IntakeInboxPage';
import AdminRelationshipsPage from './pages/admin/RelationshipsPage';
import AdminEntityGraphPage from './pages/admin/EntityGraphPage';

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="entities" element={<EntitiesPage />} />
          <Route path="entities/:entityId" element={<EntityPage />} />
          <Route path="cards/:cardId" element={<CardPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="corrections" element={<CorrectionsPage />} />
          <Route path="terms" element={<TermsPage />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>

        {/* Admin routes */}
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route
          path="/admin"
          element={
            <RequireAuth>
              <Layout isAdmin />
            </RequireAuth>
          }
        >
          <Route index element={<AdminDashboardPage />} />
          <Route path="dashboard" element={<AdminDashboardPage />} />
          <Route path="cards/new" element={<AdminCardEditPage />} />
          <Route path="cards/:cardId/edit" element={<AdminCardEditPage />} />
          <Route path="sources/new" element={<AdminSourceNewPage />} />
          <Route path="review-queue" element={<AdminReviewQueuePage />} />
          <Route path="intake" element={<AdminIntakeInboxPage />} />
          <Route path="relationships" element={<AdminRelationshipsPage />} />
          <Route path="graph" element={<AdminEntityGraphPage />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
